$(document).ready(function() {
  $(".custom_collection_page_color-swatch input[type='radio']").on("change", function() {
    var $currentGridItem = $(this).closest(".grid__item");
    $currentGridItem.find(".color_colection_custom_img").hide();
    
    var labelId = $(this).attr("id"); 
    var selectedLabel = $currentGridItem.find("label[for='" + labelId + "']"); 

    var firstImage = selectedLabel.find(".color_colection_custom_img").first(); 
    var firstImageSrc = firstImage.attr("src") || ""; 
    var firstImageSrcset = firstImage.attr("srcset") || ""; 
    var firstImageSizes = firstImage.attr("sizes") || ""; 
    var firstImageAlt = firstImage.attr("alt") || ""; 

    var newImageTag = '<img srcset="' + firstImageSrcset + '" src="' + firstImageSrc + 
                      '" sizes="' + firstImageSizes + '" alt="' + firstImageAlt + 
                      '" class="motion-reduce custom_addimage_collection_render" width="1080" height="1350">';

    $currentGridItem.find(".card__media .custom_addimage_collection_render").replaceWith(newImageTag);
  });


});

$(document).ready(function(){

  
  $(".click_size_chart").click(function(){
    $(".size-chart-popup").addClass("show-popup");
    $(".custom-size-overlay").addClass("custom-overlay");
     $("body").addClass("overflow-hidden");
  });

  $(document).on("click", ".close-popup", function(){
    $(".size-chart-popup").removeClass("show-popup");
        $(".custom-size-overlay").removeClass("custom-overlay");
         $("body").removeClass("overflow-hidden");
  });

  $(document).on("click", function(event){
    if(!$(event.target).closest(".size-chart-popup").length && !$(event.target).hasClass("click_size_chart")) {
    $(".size-chart-popup").removeClass("show-popup");
    $(".custom-size-overlay").removeClass("custom-overlay");
    $("body").removeClass("overflow-hidden");
    }
  });
  var indicator = $(".main-c-indicator").html();
  var shipping = $(".main-c-shiiping").html();
  $(indicator).insertBefore(".product-form");
    $(shipping).insertBefore(".product-form");
  
});


// $(document).ready(function(){
//   function updateImages(selectedVariant) {
//     $(".product--stacked ul.product__media-list li").hide();
//     $(".product--stacked ul.product__media-list li img[alt='" + selectedVariant + "']").closest("li").show();
//   }
  
//   $(".product--stacked .custom_click_img-Color input").change(function(){
//     var selectedVariant = $(this).val();
//     updateImages(selectedVariant);
//   });

//   $(".product--stacked ul.product__media-list li").show();
// });


// $(document).ready(function(){
//   function updateImages(selectedVariant) {
//     $("ul.thumbnail-list li.thumbnail-list__item").hide(); 
//     $("ul.thumbnail-list li.thumbnail-list__item img[alt='" + selectedVariant + "']").closest("li.thumbnail-list__item").show();
//   }
  
//   $(".custom_click_img-Color input").change(function(){
//     var selectedVariant = $(this).val();
//     updateImages(selectedVariant);
//   });

//   $("ul.thumbnail-list li.thumbnail-list__item").show(); 
// });

$(document).ready(function(){
  function updateImages(selectedVariant) {
    $("ul.product__media-list li").hide(); 
    $("ul.product__media-list li img[alt='" + selectedVariant + "']").closest("li").show();
  }
  
  $(".custom_click_img-Color input").change(function(){
    var selectedVariant = $(this).val();
    updateImages(selectedVariant);
  });

  $("ul.product__media-list li").show(); 
});


// quick add custom

// $(document).ready(function() {
//   // Add click event listener to all quick add buttons
//   $('.quick-add__submit_custom').on('click', function(event) {
//     event.preventDefault(); // Prevent default form submission
// $(".custom_open_modal").addClass("active");
//     // Get the product URL and modal ID from the data attributes
//     var productUrl = $(this).data('product-url');
//     var modalId = $(this).attr('aria-labelledby').split(' ')[1]; // Extract modal ID
  
//     // Show the modal
//     var $modal = $('#QuickAdd-' + modalId);
//     if ($modal.length) {
//       $modal.show(); // Show the modal (make sure you have CSS to handle visibility)
//     }

//     // Fetch the HTML content from the product URL
//     $.get(productUrl, function(html) {
//       // Create a temporary DOM element to parse the HTML
//       var $tempDiv = $('<div>').html(html);
//       // Extract the content of the first #MainProduct- section
//       var $content = $tempDiv.find('[id^=MainProduct-]').html();
//                console.log($content)
//       $(".quick-add-modal__content-info").html($content)
//       // Update the modal content
//       var $modalContent = $('#QuickAddInfo-' + modalId);
//       if ($modalContent.length && $content.length) {
//         $modalContent.html($content.html()); // Append the HTML content
        
//       }
//     }).fail(function() {
//       console.error('Error fetching product content');
//     });
//   });

//   // Add click event listener to close the modal
//   $('.button_close_custom').on('click', function() {
//     $(".custom_open_modal").removeClass("active");
//     var $modal = $(this).closest('.quick-add-modal');
//     if ($modal.length) {
//       $modal.hide(); // Hide the modal
//     }
//   });
// });


$(document).ready(function() {
    var prevArrow = '<button type="button" class="slick-prev"><svg role="presentation" focusable="false" width="5" height="8" class="icon icon-chevron-left-small reverse-icon" viewBox="0 0 5 8"><path d="m4.25 7-3-3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path></svg></button>';
    var nextArrow = '<button type="button" class="slick-next"><svg role="presentation" focusable="false" width="5" height="8" class="icon icon-chevron-right-small" viewBox="0 0 5 8"><path d="m.75 7 3-3-3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path></svg></button>';

    $('.inner_select_product_custom').slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        appendArrows: $('.custom_product-slider-btns'),
          responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2.1,
            slidesToScroll: 1
          }
        }
      ]
    });
});
$(document).ready(function() {
    $('.quick-add__submit_custom').on('click', function() {
        // $('#popup-overlay, #custom-popup').fadeIn();
    });
    
    $(' #closePopup, #popup-overlay').on('click', function() {
 $("body").removeClass("upcartPopupShow");
        $('#popup-overlay, #custom-popup').fadeOut();
    });
  $("#quick_buy_closePopup").on("click",function(){
      $(".quick_buy_drawer , .popup-overlay").hide();
    $("body").removeClass("upcartPopupShow");
      $("#upCart").show();
      $(".upcart-header-close-button").trigger("click");
  })

$("#cart__btn").on("click", function(event) {
        event.preventDefault(); 
  $(".quick_buy_drawer").hide();
  $("div#popup-overlay").hide();
  $(".drawer").addClass("active");
  $(".drawer").removeClass("is-empty");
        // var url = "/cart";
        // window.location.replace(url);
    });

  
// product popup  custom 

$(".custom_click_img-Color input").change(function() {
  setTimeout(function() {
  var customproductimage = $(".product-media-container .product__media.media").html();
    console.log(customproductimage)
  $(".custom-popup_product-grid .product_image_left").html(customproductimage);
  }, 100); 
});

});




$(document).on('click', '.quick-add__submit_custom', function(event) {
    
    event.preventDefault(); // Prevent default form submission
var gift3 = $(".checkouit_product_C").attr("data-variant-id");
  var giftincart2 = $("tr.cart-item.hide_checkout_product ").attr("data-variant-id_cus");

  if( gift3 === giftincart2 ){
$(".checkout_remove_cus").each(function() {
    $(this).data("html", $(this).html()); 
    $(this).html(''); // Clear inner HTML
});
  }
    else{
        setTimeout(function() {
         $(".cart-insurance-input").attr('checked', true);
        $(".cart-insurance-input").removeClass('active'); 
    }, 1000);
    var checkoutid1 = $(".checkouit_product_C").attr("data-variant-id");
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
            quantity: 1,
            id: checkoutid1
        },
        success: function() {
            updateCartDrawer();
        },
        error: function(xhr) {
            console.error("Error adding item:", xhr.responseText);
        }
    });

    }

  

  
    $('#popup-overlay, #custom-popup').fadeIn();
   // Clear existing content
        $(".custom-popup-header .img-wrapper").empty();
        $(".custom-popup-header .img-wrapper22").empty();
        $(".custom-popup-header-content .custom_show_title").empty();
        $(".custom_price_append").empty();
        $(".append_custom_reviews").empty();
        $(".custom-popup-body .append_size_custom").empty();
        $(".custom-popup-body .append_qty_custom").empty();
        $(".custom-popup-footer").empty();
    // Show the loading spinner
 $("#custom-popup").hide();
   setTimeout(function() { 
       $("#custom-popup").show();
  }, 1000);
$(".img-wrapper22").hide();
  $(".img-wrapper").show();
  
    $(".custom_product_select .loading__spinner").removeClass("hidden");

    var productUrl = $(this).attr('data-product-url_custom');

    $.get(productUrl, function(html) {
        var $tempDiv = $('<div>').html(html);
        var $content = $tempDiv.find('[id^=MainProduct-]');
      
        var $titleDiv = $content.find("div.product__title"); // Select the div with class product__title
           var titleHtml = `<div class="product__title">${$titleDiv.html()}</div>`; // Construct the HTML string
          var price = $content.find(".cuatom_added_price_class").prop('outerHTML'); // Get the full HTML of the div with class product__title
             var variant = $content.find("variant-selects").prop('outerHTML');
// $content.find(".product-form__buttons").html("<button class='atc_custom_quick product-form__submit' type='submit'>add to cart</button>");
var qty = $content.find(".product-form__input.product-form__quantity").prop('outerHTML');
 var image  = $content.find("ul.product__media-list img").prop('outerHTML');
 var image11  = $content.find("ul.product__media-list").prop('outerHTML');
var review = $content.find("#shopify-block-loox_reviews_loox_rating_DRXA6N").prop('outerHTML');
      var atc = $content.find(".product-form").prop('outerHTML');



$(".custom-popup-header .img-wrapper").html(image);
$(".custom-popup-header .img-wrapper22").html(image11);

$(".custom-popup-header-content .custom_show_title").html(titleHtml);
$(".custom_price_append").html(price);
      $(".append_custom_reviews").html(review);
     
$(".custom-popup-body .append_size_custom").html(variant);
      $(".custom-popup-body .append_qty_custom").html(qty);
     $(".custom-popup-footer").html(atc);

$(".custom_popup_click .custom_click_img-Color input").change(function() {

  $(".custom_popup_click .img-wrapper").hide();
$(".custom_popup_click .img-wrapper22").show();

    var value = $(this).val(); // Get the input value
      // Update the span text with the input value
    $(".custom_popup_click #selected-color").text(" " + value);
    // Hide all li elements
    $(".custom-popup .product__media-item").hide();

    // Loop through each img element
    $(".custom-popup .product-media-container .product__media.media img").each(function() {
        var imgAlt = $(this).attr("alt"); // Get the alt attribute of the current img
        
        if (imgAlt && imgAlt === value) {
            // If the alt matches the value, show the closest li
         $(this).closest(".product__media-list li").show();
           $li.addClass("show-class");
        }
    });
});   

// staert atc
      
$(".custom-popup-footer .product-form__submit").on("click", function(event) {
    event.preventDefault(); // Prevent default form submission
    $("#upCart").hide();
    $(".custom-popup").hide();
    // $(".popup-overlay").hide();
    var inputval = $(".custom-popup-footer .product-form").find(".product-variant-id").val();
    var quantity = $(".append_qty_custom .quantity__input").val();

    
    if (inputval && quantity) {
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
                id: inputval,
                quantity: quantity
            },
            dataType: "json",
            success: function(response) {
                $(".quick_buy_drawer").show();

                
                var lastItem = response;             
                var imageUrl = lastItem.featured_image ? lastItem.featured_image.url : lastItem.image;
                var formattedPrice = Shopify.formatMoney ? Shopify.formatMoney(lastItem.price) : (lastItem.price / 100).toFixed(2);
                var comparePrice = lastItem.final_line_price ? (Shopify.formatMoney ? Shopify.formatMoney(lastItem.final_line_price) : (lastItem.final_line_price / 100).toFixed(2)) : null;
        
                var variantTitle = lastItem.variant_title;
                
                var itemHtml = `
                    <div class="cart-item_quick_buy">
                    <div class="img-wrapper">
                        <img src="${imageUrl}" alt="${lastItem.title}" />
                        </div>
                        <div class="flex_cutom">
                        <p class="quick_buy_title"> ${lastItem.title}</p>
                          <div class="comare_quick_main">       
                         ${price ? `<p class="compare-price">${price}</p>` : ''}
                        </div>
                      ${variantTitle ? `<p class="quick_buy__variant">${variantTitle}</p>` : ''}
                      
                        </div>
                    </div>
                `;

                console.log("HTML of the added item:", itemHtml);

                $(".show_item_product").html(itemHtml);
              updateCartDrawerquick();

            },
            error: function(error) {
                console.error("Error adding product to cart", error);
                alert('There was an error adding the product to the cart.');
            }
        });
       function updateCartDrawerquick() {
        $.ajax({
          type: 'GET',
          url: '/cart',
        //   success: function(cartPageHtml) {
        //             var cartdata = $(cartPageHtml).find(".cart-drawer").html();
        //   $(".cart-drawer").html(cartdata);
        //     var cartbuble = $(cartPageHtml).find(".cart-count-bubble").html();
        // $(".cart-count-bubble ").removeClass("hidden");
        //    $('.cart-count-bubble').html(cartbuble);
  
            
        //   },
                 success: function(cartPageHtml) {
            var $newCartContent = $(cartPageHtml).find('.drawer__inner'); 
       var bubbleCount = $(cartPageHtml).find('.cart-count-bubble .custom-bubble').text(); 
            
            $('.cart-count-bubble .custom-bubble').text(bubbleCount); 

            $('.drawer__inner').html($newCartContent.html()); 
            var itemCount = $newCartContent.find('.cart-item').length; 
            if (itemCount === 0) {
                $('.drawer').addClass('is-empty'); 
                $('.cart-count-bubble').text(0); 
            } else {
                $('.drawer').removeClass('is-empty'); 
                $('.cart-count-bubble').text(itemCount); 
            }
        },
          error: function(xhr) {
            console.error('Error fetching cart page:', xhr.responseText);
          }
        });
      }
    } else {
        alert('Please select a variant and quantity.');
    }




  // quantity update 
   $(document).on('click', '.quantity__button', function(event) {
  event.preventDefault(); // Prevent default behavior
 
      var val = $(this).closest("quantity-input.quantity").find(".quantity__input").val();
       var id = $(this).closest(".quantity").find(".quantity__input").attr("data-quantity-variant-id");   

       $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: { quantity:val, id: id},
        success:function(cart){ 
      console.log("updates")
          updateCartDrawerquick();
          }         
        });
     
      });
  // remove item

$(document).on('click', '.cart-remove-button', function(event) {
  event.preventDefault(); // Prevent default behavior

  var variantId = $(this).attr('data-variant-id');

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
      quantity: 0,
      id: variantId
    },
    success: function(cart) {
      console.log("Item removed");

      updateCartDrawerquick();

    },
    error: function(xhr, status, error) {
      console.error("Error removing item:", error);
    }
  });
});

});


// end atc
      
    }).fail(function() {
        // Hide the loading spinner in case of an error

    });

});


// upsell

  $(document).ready(function() {
  
      $(document).on('click', '.upsell__add-btn', function() {
        var $button = $(this);
        var $spinner = $button.find(".loading__spinner");

     
        $spinner.removeClass("hidden");

      
        var hideSpinner = function() {
          setTimeout(function() {
            $spinner.addClass('hidden');
          }, 500);
        };

        var productId = $button.data('product-id');
        var variantSelect = $('#variant-select-' + productId);
        var variantId = variantSelect.length ? variantSelect.val() : $button.data('default-variant-id');

   
        if (!variantId) {
          variantId = $button.data('default-variant-id');
        }

        var dataToSend = { id: variantId, quantity: 1 };

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: dataToSend,
          dataType: 'json',
          success: function(response) {
            console.log('Product added to cart:', response);
            updateCartDrawer();
          },
          error: function(xhr) {
            console.error('Error adding product to cart:', xhr.responseText);
          },
          complete: hideSpinner
        });
      });

      $(document).on('change', '.variant-select', function() {
        var selectId = $(this).attr('id');
        var productId = selectId.split('-').pop();
        var selectedOption = $(this).find('option:selected');
        var newImageSrc = selectedOption.data('image');

        $('#product-image-' + productId).attr('src', newImageSrc);
      });

      function updateCartDrawer() {
        $.ajax({
          type: 'GET',
          url: '/cart',
          // success: function(cartPageHtml) {
          //   var $cartPage = $(cartPageHtml);
          //   var newCartHtml = $cartPage.find('.cart__contents').html();
          //   var newCartHtml1 = $cartPage.find('.totals__total-value').html();
          //   var saving_value = $cartPage.find('.totals__savings-value').html();
          //   var drawer_heading = $cartPage.find('.drawer__heading').html();
          //   var buble = $cartPage.find('.cart-count-bubble').html();
          //   $('.cart-drawer .cart__contents').html(newCartHtml);
          //   $('.cart-drawer .cart-drawer__footer .totals__total-value').html(newCartHtml1);
          //   $('.cart-drawer .cart-drawer__footer .totals__savings-value').html(saving_value);
          //   $('.cart-drawer .drawer__heading').html(drawer_heading);
          //   $('.cart-count-bubble').html(buble);

          //            var itemCount = $(cartPageHtml).find('.cart-item').length; 
          //   alert(itemCount)
          //   if (itemCount === 0) {
          //       $('.drawer').addClass('is-empty'); 
          //       $('.cart-count-bubble').text(0); 
          //   } else {
          //       $('.drawer').removeClass('is-empty'); 
          //       $('.cart-count-bubble').text(itemCount); 
          //   }
          // },
                  success: function(cartPageHtml) {
            var $newCartContent = $(cartPageHtml).find('.drawer__inner'); 
            var bubbleCount = $(cartPageHtml).find('.cart-count-bubble .custom-bubble').text(); 
            
            $('.cart-count-bubble .custom-bubble').text(bubbleCount); 

            $('.drawer__inner').html($newCartContent.html()); 
            var itemCount = $newCartContent.find('.cart-item').length; 
            if (itemCount === 0) {
                $('.drawer').addClass('is-empty'); 
                $('.cart-count-bubble').text(0); 
            } else {
                $('.drawer').removeClass('is-empty'); 
                $('.cart-count-bubble').text(itemCount); 
            }
        },
          error: function(xhr) {
            console.error('Error fetching cart page:', xhr.responseText);
          }
        });
      }
















// checkout on of
$(".product-form__submit.button").on("click", function(event){
  var custom2 = $(".checkout_remove_cus_form").html();
    $(".checkout_remove_cus").html(custom2);

var gift3 = $(".checkouit_product_C").attr("data-variant-id");
  var giftincart2 = $("tr.cart-item.hide_checkout_product ").attr("data-variant-id_cus");

  if( gift3 === giftincart2 ){
$(".checkout_remove_cus").each(function() {
    $(this).data("html", $(this).html()); 
    $(this).html(''); // Clear inner HTML
});


setTimeout(function() {
    $(".checkout_remove_cus").each(function() {
        $(this).html($(this).data("html")); 
    });
}, 1700); 
  }

  
    // for free product
    var customfree = $(".checkout_remove_cus_form_free").html();
    $(".checkout_remove_cus_form_freephtml").html(customfree);
  var gift4 = $(".free_product_C").attr("data-variant-id");
  
  var giftincart5 = $("tr.cart-item.hide_giftcus_product ").attr("data-variant-id_cus");
  if( gift4 === giftincart5 ){
 $(".checkout_remove_cus_form_freephtml").each(function() {
    $(this).data("html", $(this).html()); 
    $(this).html(''); // Clear inner HTML
});


 setTimeout(function() {
    $(".checkout_remove_cus_form_freephtml").each(function() {
        $(this).html($(this).data("html")); 
    });
 }, 1700); 

  }
  
  setTimeout(function() {
     $(".cart-insurance-input").setAttribute('checked'); 
  }, 2000); 
});





// checkout upsell remove product
$(document).on("click", ".cart-insurance-input[checked]", function(event) {
    $('.cart-item.hide_checkout_product').find('cart-remove-button').trigger('click');
    setTimeout(function() {
              $(".cart-insurance-input").removeAttr('checked'); 
              $(".cart-insurance-input").addClass('active'); 
  }, 500); 


    var checkoutid = $("tr.cart-item.hide_checkout_product").attr("data-variant-id_cus");
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            quantity: 0,
            id: checkoutid
        },
        success: function() {
            updateCartDrawer();
        },
        error: function(xhr) {
            console.error("Error removing item:", xhr.responseText);
        }
    });


 
});



    // checkout upsell add product
$(document).on("click", "input.cart-insurance-input.active", function(event) {
    var $clickedInput = $(this);

    setTimeout(function() {
        $clickedInput.attr('checked', true);
        $(".cart-insurance-input").removeClass('active'); 
    }, 800);

    var checkoutid1 = $(".checkouit_product_C").attr("data-variant-id");
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
            quantity: 1,
            id: checkoutid1
        },
        success: function() {
            updateCartDrawer();
        },
        error: function(xhr) {
            console.error("Error adding item:", xhr.responseText);
        }
    });
});



    $(document).on('click', '.cart-remove-button', function(event) {
  event.preventDefault(); // Prevent default behavior

  var variantId = $(this).attr('data-variant-id');

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
      quantity: 0,
      id: variantId
    },
    success: function(cart) {
      console.log("Item removed");

      updateCartDrawerquick();

    },
    error: function(xhr, status, error) {
      console.error("Error removing item:", error);
    }
  });
});
      $(document).on('click', '.quantity__button', function(event) {
  event.preventDefault(); // Prevent default behavior
 
      var val = $(this).closest("quantity-input.quantity").find(".quantity__input").val();
       var id = $(this).closest(".quantity").find(".quantity__input").attr("data-quantity-variant-id");   

       $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: { quantity:val, id: id},
        success:function(cart){ 
      console.log("updates")
          updateCartDrawerquick();
          }         
        });
     
      });
           function updateCartDrawerquick() {
        $.ajax({
          type: 'GET',
          url: '/cart',
        //   success: function(cartPageHtml) {
        //             var cartdata = $(cartPageHtml).find(".cart-drawer").html();
        //   $(".cart-drawer").html(cartdata);
        //     var cartbuble = $(cartPageHtml).find(".cart-count-bubble").html();
        // $(".cart-count-bubble ").removeClass("hidden");
        //    $('.cart-count-bubble').html(cartbuble);
  
            
        //   },
                 success: function(cartPageHtml) {
            var $newCartContent = $(cartPageHtml).find('.drawer__inner'); 
            var bubbleCount = $(cartPageHtml).find('.cart-count-bubble .custom-bubble').text(); 
            
            $('.cart-count-bubble .custom-bubble').text(bubbleCount); 

            $('.drawer__inner').html($newCartContent.html()); 
            var itemCount = $newCartContent.find('.cart-item').length; 
            if (itemCount === 0) {
                $('.drawer').addClass('is-empty'); 
                $('.cart-count-bubble').text(0); 
            } else {
                $('.drawer').removeClass('is-empty'); 
                $('.cart-count-bubble').text(itemCount); 
            }
        },
          error: function(xhr) {
            console.error('Error fetching cart page:', xhr.responseText);
          }
        });
      }




$(document).on("click", ".removebtnnew", function(event) {
    $('.cart-item.hide_checkout_product').find('cart-remove-button').trigger('click');
  setTimeout(function() {
              $(".cart-insurance-input").removeAttr('checked'); 
              $(".cart-insurance-input").addClass('active'); 
  }, 500); 


    var checkoutid = $("tr.cart-item.hide_checkout_product").attr("data-variant-id_cus");
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            quantity: 0,
            id: checkoutid
        },
        success: function() {
            updateCartDrawer();
        },
        error: function(xhr) {
            console.error("Error removing item:", xhr.responseText);
        }
    });


 
});


    
    });


$(window).on('load', function() {

var custominput = $("body").attr("data-variant-id");
var ourcart = $("tr.cart-item.hide_checkout_product").attr("data-variant-id_cus");

if (custominput == ourcart) {
    $(".cart-insurance-input").prop('checked', true);
    console.log("matched");
} else {
    $(".cart-insurance-input").prop('checked', false);
    $(".cart-insurance-input").addClass('active');
    console.log("no....");
}


  
  // Iterate through each grid item
  $('.product-grid .grid__item').each(function() {
    // Find the first radio input with name="color" in the current grid item
    var firstColorInput = $(this).find('.custom_collection_page_color-swatch input[name="color"]').first();

    // Check if the input exists
    if (firstColorInput.length) {
      // Check the first radio button
      firstColorInput.prop('checked', true);
      
      // Optional: Update the label to reflect the checked state
      firstColorInput.closest('.custom_collection_page_color-swatch').find('label').removeClass('selected'); // remove selected class from all labels
      firstColorInput.next('label').addClass('selected'); // add selected class to the current label
      
      // Log the ID and value of the first radio button
      console.log('First Color Input ID:', firstColorInput.attr('id'));
      console.log('First Color Input Value:', firstColorInput.val());
    } else {
      console.log('No color input found in this grid item.');
    }
  });
});


$(document).ready(function(){
$(".custom-mobile-dropdown").click(function(e) {
    var dropdown = $(this).closest(".has-dropdown-custom-mobile").find(".dropdown-custom-mobile");
    dropdown.stop(true, true).slideToggle();
    dropdown.parent().toggleClass("active");
});
});



// checkout upsell remove product


// $(document).on("click", ".removebtnnew", function(event) {
// setTimeout(function() {
//               $(".cart-insurance-input").removeAttr('checked'); 
//               $(".cart-insurance-input").addClass('active'); 
//       $('.cart-item.hide_checkout_product').find('cart-remove-button button').trigger('click');
//   }, 900); 


//   //   var checcarkoutid = $("tr.cart-item.hide_checkout_product").attr("data-variant-id_cus");
//   // alert(checcarkoutid)
//   //   $.ajax({
//   //       type: 'POST',
//   //       url: '/cart/change.js',
//   //       dataType: 'json',
//   //       data: {
//   //           quantity: 0,
//   //           id: checkoutid
//   //       },
//   //       success: function() {
//   //           updateCartDrawer();
//   //       },
//   //       error: function(xhr) {
//   //           console.error("Error removing item:", xhr.responseText);
//   //       }
//   //   }); 
// });

$(document).ready(function() {
   $(document).ready(function() {
    $('.allow-dropdown-custom').on('click', function() {
        const $clickedItem = $(this);
        const $clickedWrapper = $clickedItem.next('.custom-header-dropsdpwn-wrapper');

        if ($clickedWrapper.is(':visible')) {
            $clickedWrapper.slideUp();
            $clickedItem.removeClass('active');
        } else {
            $('.custom-header-dropsdpwn-wrapper').slideUp();
            $('.allow-dropdown-custom').removeClass('active');

            $clickedWrapper.slideDown();
            $clickedItem.addClass('active');
        }
    });
});

});





